import React, { Component } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { Table } from "react-bootstrap";
import Scrollbar from "react-scrollbars-custom";
import "./FailedReportsModal.css";

class FailedReportsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { onToggleModal, reports } = this.props;

    return (
      <SweetAlert
        customClass="FailedReportsModal__SweetAlert"
        title=""
        showConfirm={false}
        onConfirm={() => {}}
        onCancel={() => onToggleModal()}
      >
        <div className="FailedReportsModal__Header">
          Uploaded failed for the following reports!
        </div>

        <Scrollbar
          disableTrackYWidthCompensation
          disableTracksWidthCompensation
          className="FailedReportsModal__Scrollbar"
        >
          <Table>
            <thead>
              <tr>
                <th className="customTh FailedReportsModal__Table__Th">
                  #
                </th>
                <th className="customTh FailedReportsModal__Table__Th">
                  Report Name
                </th>
              </tr>
            </thead>
            <tbody>
              {reports.map((item, i) => (
                <tr key={i} className="FailedReportsModal__Table__Tr">
                  <td>
                    {" "}
                    {i + 1}
                    {" "}
                  </td>
                  <td>
                    {" "}
                    {item}
                    {" "}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Scrollbar>
      </SweetAlert>
    );
  }
}

export default FailedReportsModal;
